export const BUNDLE_LIST = [
  {
    key: "TYPE",
    value: "type",
    width: 0.27,
  },
  {
    key: "SUBSCRIPTION",
    value: "subscription",
    width: 0.7,
  },
  {
    key: "DO NOT SHIP",
    value: "donotship",
    width: 0.27,
  },
  {
    key: "ASSIGNED HARDWARE",
    value: "assignedhardware",
    width: 0.7,
  },
  {
    key: "HARDWARE SPECIFIER",
    value: "hardwarespecifier",
    width: 0.7,
  },
  {
    key: "LINE TYPE",
    value: "linetype",
    width: 0.2,
  },
  {
    key: "HARDWARE CHANGES",
    value: "hardwarechanges",
    width: 0.8,
  },
  {
    key: "APPROVED CHANGES",
    value: "approvedchanges",
    width: 0.8,
  },
];

export const BADGE_STYLE = {
  core: {
    backgroundColor: "#0077B4",
    color: "white",
  },
  feature: {
    backgroundColor: "white",
    color: "black",
  },
  companion: {
    backgroundColor: "black",
    color: "white",
  },
};

export const HARDWARE_REQUEST_STATUS = {
  CREATED: "Created",
  MODIFIED_PENDING_AGENT: "Pending Agent",
  MODIFIED: "Modified",
  REVERTED_PENDING_AGENT: "Pending Agent",
  CANCELLED: "Cancelled",
  CLEARED: "Cleared",
  APPROVED: "Approved",
  REVERTED: "Reverted",
  PENDING_AGENT: "Pending Agent",
};

export const HARDWARE_REQUEST_STATUS_CONSTANT = {
  CREATED: "CREATED",
  MODIFIED_PENDING_AGENT: "MODIFIED_PENDING_AGENT",
  MODIFIED: "MODIFIED",
  REVERTED_PENDING_AGENT: "REVERTED_PENDING_AGENT",
  CANCELLED: "CANCELLED",
  APPROVED: "APPROVED",
  REVERTED: "REVERTED",
  CLEARED: "CLEARED",
};
